<template>
    <b-form-group class="input" :label="label" :label-for="id" :invalid-feedback="validationErrorMessage">
      <b-input-group>
        <b-input-group-prepend v-if="icon">
          <p class="h4 m-auto pr-3"><b-icon :icon="icon"></b-icon></p>
        </b-input-group-prepend>
        <b-form-input @blur="blurred" @focus="focused" @input="onInput" :state="validationState" :value="value" name="username" v-bind="$attrs"/>
      </b-input-group>
    </b-form-group>
</template>

<script>
    import {validationUtilsService} from "../../services/validation-utils.service";

    export default {
        name: "ValidationInput",
        props: {
            id: String,
            value: String,
            label: String,
            icon: String,
            mustMatch: String,
            validation: {}
        },
        computed: {
            validationState() {
                return validationUtilsService.validateField(this.validation, this.id, this.value, this.mustMatch)
            },
            validationErrorMessage() {
              if(this.validation[this.id] !== undefined && this.validation[this.id].dirty !== undefined && this.validation[this.id].dirty === true) {
                return validationUtilsService.getFieldErrorMessage(this.validation, this.id, this.value, this.mustMatch)
              } else {
                return "";
              }
            }
        },
        methods: {
            onInput(e) {
                // You can conditionally do this after validation
                this.$emit('input', e);
            },
            blurred() {
                if(this.validation[this.id].dirty === false) {
                    this.validation[this.id].dirty = true;
                }
            },
            focused() {
              if(this.validation[this.id] !== undefined)
                if(this.validation[this.id].dirty === true) {
                  this.validation[this.id].dirty = false;
                }
                this.$emit('focus');
            }
        }
    };
</script>

<style scoped>
</style>
